var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 4.44771 7.44771 4 8 4H26C26.5523 4 27 4.44771 27 5C27 5.55229 26.5523 6 26 6H8C7.44772 6 7 5.55229 7 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 10.3431 8.34315 9 10 9H32C33.6569 9 35 10.3431 35 12V18C35 19.6569 33.6569 21 32 21H10C8.34315 21 7 19.6569 7 18V12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24C7.44772 24 7 24.4477 7 25C7 25.5523 7.44771 26 8 26H18C18.5523 26 19 25.5523 19 25C19 24.4477 18.5523 24 18 24H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardScreen);
export default __webpack_public_path__ + "static/media/standardScreen.c9fda9d577bdde58dab4b0a83f210ee3.svg";
export { ForwardRef as ReactComponent };